module.exports = __webpack_public_path__ + "static/img/db_logo.30486aa9.png";